import createReactClass from 'create-react-class';
import React from 'react';
import Constants from '../constants/constants';

import { Button, Modal } from 'react-bootstrap';

import { restrictionRequestStore } from '../stores/restrictionRequest';
import { userStore } from '../stores/user';
import { territoryStore } from '../stores/territory';
import { FormRequestActions } from '../actions/formRequestActions';
import { ErrorAction } from '../actions/errorActions';
import { ConfirmationModalActions } from '../actions/submissionConfirmationModalActions';
var TYPES = Constants.RestrictionTypes;

export const TransferModal = createReactClass({
    componentDidMount: function () {
        territoryStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        territoryStore.unsubscribe(this._onChange);
    },
    //React api
    getInitialState() {
        return { showModal: false, territoryName: territoryStore.getSelectedTerritory() };
    },

    close() {
        //call action creator to store the comment here...
        this.setState({ showModal: false });
    },

    cancel() {
        this.setState({ showModal: false });
    },

    open() {
        //only open the modal if the form validates
        var canSubmit = restrictionRequestStore.formValid();
        if (!canSubmit) {
            //event.stopPropagation();
            //window.alert('Request submission failed.\nErrors were found on this request. Please fix all errors and submit again.')
            ErrorAction.showModalError('Request submission failed.\nErrors were found on this request. Please fix all errors and submit again.');
        }
        else {
            this.setState({ showModal: true });
        }
        ConfirmationModalActions.validateBeforeSubmitting();
    },

    onChange(e) {
        this.setState({ showModal: true });
    },

    onSelectChange(event) {
        this.setState({ showModal: true });
        FormRequestActions.selectChanged("transferredDsId", event.target.value);
    },

    submit: function () {
        this.props.submitAction();
        this.setState({ showModal: false });
    },

    //React api function
    render: function () {
        var buttonText = this.props.buttonText;
        var component;
        var form = this.props.form;
        var role = userStore.getSelectedRole();
        var territoryList = territoryStore.getTerritoryList();
        var selectionList;
        var formType = restrictionRequestStore.getFormType();
        //Hide the DS owner from the 'Transfer To' drop down if the owner
        //already present under the restriction

        //Super user and admin
        //Form A should be shown with T
        //Form B should be shown with A and T
        var formBValid = ['A', 'T']
        var formAValid = ['T']
        var isFormA = (formType == TYPES.A)

        if (form.dispatchers != null) {
            for (var i = 0; i < form.dispatchers.length; i++) {
                if (isFormA) {
                    if (form.dispatchers[i].status.trim() !== 'T') {
                        territoryList = territoryList.filter(function (dispatcher) {
                            return dispatcher.name.trim() !== form.dispatchers[i].dsid.trim()
                        });
                    }
                } else {
                    if ((form.dispatchers[i].status.trim() !== 'T') && (form.dispatchers[i].status.trim() !== 'A')) {
                        territoryList = territoryList.filter(function (dispatcher) {
                            return dispatcher.name.trim() !== form.dispatchers[i].dsid.trim()
                        });
                    }

                }
            }
        }

        var tName = "";
        if (this.state.territoryName) {
            tName = this.state.territoryName.trim();
        }

        if (role.indexOf(Constants.Roles.ADMIN) > -1 ||
            (role.indexOf(Constants.Roles.DISPATCHER) > -1 && (form.dispatchers == null))) {

            selectionList = territoryList.map(function (input) {
                if (input.name.trim() === tName) return
                return (<option key={input.name.trim()} value={input.name.trim()}>{input.name.trim()}</option>);
            });
        }
        else {
            if (form.dispatchers != null) {

                selectionList = form.dispatchers.map(function (input) {
                    if (input.status == "O" || input.status == "T" || (input.dsid.trim() == tName)) {
                        return
                    }
                    return (<option key={input.dsid.trim()} value={input.dsid.trim()}>{input.dsid.trim()}</option>);
                });
            }
        }

        component = (
            <div>
                <label>
                    *Transfer to:
                </label>
                <select id="owner"
                    onChange={this.onSelectChange}
                    onBlur={this.onBlur}
                    value={form.transferredDsId}
                    defaultValue=""
                    name="owner"
                    style={{ width: '120px' }}
                    required>
                    <option value="" disabled>Select...
                    </option>
                    {selectionList}
                </select>
            </div>
        );
        return (
            <div>
                <Button
                    id="submitButton"
                    bsStyle='primary'

                    disabled={this.props.disabled}
                    onClick={this.open}>
                    {buttonText}
                </Button>
                <Modal dialogClassName="transferModal" onHide={this.close}
                    show={this.state.showModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Transfer</Modal.Title>
                    </Modal.Header>

                    <div className='modal-body'>
                        {component}
                    </div>
                    <div className='modal-footer'>
                        <span className="deetsQuestionSpan">Are you sure you want to {this.props.question}?</span>
                        <Button id="confirmSubmitButton" bsStyle='danger'
                            onClick={this.submit}>{buttonText}</Button>
                        <Button id="cancelConfirmButton" onClick={this.cancel}>Cancel</Button>
                    </div>
                </Modal>
            </div>
        );
    },
});
